// #3 — Eindeutige Eigen-Transfer-Kandidaten automatisch übernehmen.
//
// „Eindeutig" = die On-Chain-Gegenadresse eines Transfers ist eine in „Meine
// Wallets" hinterlegte eigene Adresse (vorhandener `classifyOwnWalletTransfers`,
// wasserdicht → INVARIANT 4: kein steuerliches Event). Solche Kandidaten werden
// über den VORHANDENEN Import-Pfad (onImport → App.handleImportCsv → addBatch)
// gebucht — mit allen Schutzschichten (Dedup, Transfer-Schutz, Re-Klassifikation).
//
// KEIN server-seitiger Ledger-Write. Idempotent: bereits übernommene Kandidaten
// werden aus `walletCandidates` entfernt; ein erneuter Lauf findet sie nicht mehr,
// und addBatch dedupt ohnehin. Alles Mehrdeutige bleibt im „Zu prüfen".
//
// Genutzt app-weit (App.js beim Start) — eine Quelle für die Auto-Übernahme.

import { listWallets } from '../services/walletRegistry';
import { listCandidates, clearCandidates } from '../services/walletCandidates';
import { classifyOwnWalletTransfers } from './ownWalletClassifier';
import { priceWalletRows } from './walletPricing';

/**
 * @returns {Promise<number>} Anzahl automatisch übernommener Kandidaten (0 = nichts getan)
 */
export async function autoImportOwnTransferCandidates({ uid, onImport } = {}) {
  if (!uid || typeof onImport !== 'function') return 0;

  let wallets = [];
  let candidates = [];
  try { wallets = await listWallets(uid); } catch { return 0; }
  if (!wallets.length) return 0;
  try { candidates = await listCandidates(uid); } catch { return 0; }
  if (!candidates.length) return 0;

  const classed = classifyOwnWalletTransfers(candidates.map(c => c.tx || {}), wallets);
  const autoIdx = classed
    .map((tx, i) => (tx && tx.ownWalletTransfer ? i : -1))
    .filter(i => i >= 0);
  if (!autoIdx.length) return 0;

  const autoIds = autoIdx.map(i => candidates[i].id);
  let rows = autoIdx.map(i => ({ ...classed[i] }));
  try { rows = await priceWalletRows(rows); }
  catch { rows = rows.map(tx => ({ ...tx, hash: tx.hash || tx.txHash || '' })); }

  await onImport(rows, {});
  await clearCandidates(uid, autoIds);
  return autoIds.length;
}
